import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResult, IInstitution } from '../../../shared/model/Index';

@Injectable({ providedIn: 'root' })

export class SharedService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }
    
    instituteSearch(value: any, isHighSchool:boolean) {
        return this.http.get<ApiResult<IInstitution[]>>(env.apiUrl + 'Lookup/GetInstitutionByValue/' + value+"/"+isHighSchool).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
}